import { lazy } from 'react'
import nav from './pages/nav'

export interface IRoute {
  title: string
  path: string
  element: any
  children?: IRoute[]
  /** 为 true 时顶部栏不显示「返回」与回主页图标（用于展示/投屏等） */
  hideNavActions?: boolean
  /** 为 true 时隐藏整条顶部栏，由页面自己接管导航 */
  hideNav?: boolean
}

const users = lazy(() => import('./pages/users/list'))
const meituan = lazy(() => import('./pages/meituan'))
const shopRecharge = lazy(() => import('./pages/shop-recharge'))
const shopPackage = lazy(() => import('./pages/shop-package'))
const shopList = lazy(() => import('./pages/shop-list'))
const orders = lazy(() => import('./pages/orders'))
const orderDetail = lazy(() => import('./pages/orders/detail'))
const orderReview = lazy(() => import('./pages/orders/review'))
const orderAftersale = lazy(() => import('./pages/orders/aftersale'))
const recharge = lazy(() => import('./pages/recharge'))
const dataList = lazy(() => import('./pages/data-list'))
const refund = lazy(() => import('./pages/refund'))
const freePark = lazy(() => import('./pages/free-park'))
const freeParkList = lazy(() => import('./pages/free-park/list'))
const freeParkListView = lazy(() => import('./pages/free-park/list-view'))
const transaction = lazy(() => import('./pages/transaction'))
const groupMapping = lazy(() => import('./pages/group-mapping'))
const blacklist = lazy(() => import('./pages/blacklist'))
const comment = lazy(() => import('./pages/comment'))
const material = lazy(() => import('./pages/material'))
const operation = lazy(() => import('./pages/operation'))
const hosting = lazy(() => import('./pages/hosting'))
const profit = lazy(() => import('./pages/profit'))
const shopMap = lazy(() => import('./pages/shop-map'))
const receiptList = lazy(() => import('./pages/receipt-list'))
const banner = lazy(() => import('./pages/banner'))
const activity = lazy(() => import('./pages/activity'))
const washQuestion = lazy(() => import('./pages/wash-question'))
const civilizedPenalty = lazy(() => import('./pages/civilized-penalty'))
const adminSetting = lazy(() => import('./pages/admin-setting'))
const updatePassword = lazy(() => import('./pages/admin-setting/password'))
const adminAuth = lazy(() => import('./pages/admin-setting/auth'))
const mapShop = lazy(() => import('./pages/map-shop'))
const mapShopMap = lazy(() => import('./pages/map-shop/map'))
const mapShopHouse = lazy(() => import('./pages/map-shop/house'))
const mapShopEval = lazy(() => import('./pages/map-shop/eval'))
const mapShopEvalForm = lazy(() => import('./pages/map-shop/eval/form'))
const deviceStatusList = lazy(() => import('./pages/shop-list/device-status'))
const machineCustomer = lazy(() => import('./pages/machine-customer'))
const joinApply = lazy(() => import('./pages/join-apply'))

// 要注册的路由
export const routes: IRoute[] = [
  {
    title: '首页',
    path: '/nav',
    element: nav,
  },
  {
    title: '用户管理',
    path: '/users',
    element: users
  },
  {
    title: '交易数据',
    path: '/transaction',
    element: transaction
  },
  {
    title: '美团授权',
    path: '/meituan',
    element: meituan
  },
  {
    title: '充值套餐管理',
    path: '/shop-recharge',
    element: shopRecharge
  },
  {
    title: '洗车套餐管理',
    path: '/shop-package',
    element: shopPackage
  },
  {
    title: '店铺管理',
    path: '/shop-list',
    element: shopList
  },
  {
    title: '订单列表',
    path: '/orders',
    element: orders
  },
  {
    title: '订单详情',
    path: '/order-detail',
    element: orderDetail
  },
  {
    title: '订单评价列表',
    path: '/order-review',
    element: orderReview
  },
  {
    title: '订单售后列表',
    path: '/order-aftersale',
    element: orderAftersale
  },
  {
    title: '充值列表',
    path: '/recharge',
    element: recharge
  },
  {
    title: '核心数据',
    path: '/data-list',
    element: dataList
  },
  {
    title: '余额退款',
    path: '/refund',
    element: refund
  },
  {
    title: '洗车免停管理',
    path: '/free-park',
    element: freePark
  },
  {
    title: '洗车对账',
    path: '/free-park-list',
    element: freeParkList
  },
  {
    title: '洗车对账展示',
    path: '/free-park-list-view',
    element: freeParkListView,
    hideNavActions: true
  },
  {
    title: '团购映射管理',
    path: '/group-mapping',
    element: groupMapping
  },
  {
    title: '黑名单',
    path: '/blacklist',
    element: blacklist
  },
  {
    title: '好评领券管理',
    path: '/comment',
    element: comment
  },
  {
    title: '物料对账',
    path: '/material',
    element: material
  },
  {
    title: '运营对账',
    path: '/operation',
    element: operation
  },
  {
    title: '托管设置',
    path: '/hosting',
    element: hosting
  },
  {
    title: '门店盈收',
    path: '/profit',
    element: profit
  },
  {
    title: '店铺映射',
    path: '/shop-map',
    element: shopMap
  },
  {
    title: '核销记录',
    path: '/receipt-list',
    element: receiptList
  },
  {
    title: '广告设置',
    path: '/banner',
    element: banner
  },
  {
    title: '疯狂洗车日',
    path: '/activity',
    element: activity
  },
  {
    title: '洗车有问题',
    path: '/wash-question',
    element: washQuestion
  },
  {
    title: '文明洗车管理',
    path: '/civilized-penalty',
    element: civilizedPenalty
  },
  {
    title: '设置',
    path: '/admin-setting',
    element: adminSetting
  },
  {
    title: '修改密码',
    path: '/admin-password',
    element: updatePassword
  },
  {
    title: '账号与权限',
    path: '/admin-auth',
    element: adminAuth
  },
  {
    title: '选址管理',
    path: '/map-shop',
    element: mapShop
  },
  {
    title: '选址地图',
    path: '/map-shop-map',
    element: mapShopMap
  },
  {
    title: '门店附近户数',
    path: '/map-shop-house',
    element: mapShopHouse
  },
  {
    title: '选址打分',
    path: '/map-shop-eval',
    element: mapShopEval
  },
  {
    title: '选址打分',
    path: '/map-shop-eval-form',
    element: mapShopEvalForm,
    hideNav: true
  },
  {
    title: '设备联网记录',
    path: '/device-status-list',
    element: deviceStatusList
  },
  {
    title: '洗车机客户管理',
    path: '/machine-customer',
    element: machineCustomer
  },
  {
    title: '意向加盟商管理',
    path: '/join-apply',
    element: joinApply
  }
]
